module.exports = "https://cdn.thelire.com/ins/resource/pic_feed_watchearn2@3x.899ce244ac3173e8e5a35cf15dfd17f5.png";